module.exports = __webpack_public_path__ + "img/e3c2304.svg";